import queryKeys from '@/constants/queryKeys';
import { mondayGetItem, mondaySetItem } from '@/services/monday';
import { useMutation, useQuery } from 'react-query';

export enum MondayStorageKeys {
  WORKFLOW_TYPE = 'workflowType',
}

export const useGetFromMondayStorageQuery = (key: MondayStorageKeys) => {
  return useQuery<string>(
    [queryKeys.MONDAY_GET_VALUE_FROM_STORAGE, key],
    async () => {
      const result = await mondayGetItem(key);
      return result?.data?.value;
    },
    {
      enabled: !!key,
      refetchOnWindowFocus: false,
    },
  );
};

export const useSetToMondayStorageQuery = (key: MondayStorageKeys) => {
  return useMutation(async (value: string) => {
    return await mondaySetItem(key, value);
  });
};
